import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { AuthProvider } from './context/AuthContext';
import { ClassProvider } from './context/ClassContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ClassProvider>
        <App />
      </ClassProvider>
    </AuthProvider>
  </React.StrictMode>
);
